import React from "react";
import { Route } from "react-router-dom";
import RecordTable from "../../components/RecordTable";
import InvoiceList from "../../components/InvoiceList";
import InvoiceTitle from "../../components/InvoiceTitle";
import MainLayout from "../../components/MainLayout";

const InvoicePage = ({ match }) => (
  <React.Fragment>
    <MainLayout />
    <Route exact path={`${match.url}`} component={RecordTable} />
    <Route path={`${match.url}/recordTable`} component={RecordTable} />
    <Route path={`${match.url}/invoiceList`} component={InvoiceList} />
    <Route path={`${match.url}/invoiceTitle`} component={InvoiceTitle} />
  </React.Fragment>
);

export default InvoicePage;
